module.exports = __webpack_public_path__ + "media/images/profile-hero-6-31d6cfe0d16ae931b73c59d7e0c089c0.jpg";